import React, { useEffect, useState } from "react";
import "./PreRegister.css";
import yoyoLogo from "../assets/YoyoLetters.png";
import logo from "../assets/tooltip.svg";
import yoyovideoMobile from "../assets/video_website_desktop.mp4";
import yoyovideoDesktop from "../assets/video_website_desktop.mp4";
import Tooltip from "./tooltip";
import FormField from "./FormField/FormField";
import PhoneNumberField from "./PhoneNumberField/PhoneNumberField";
import BackButton from "./BackButton/BackButton";
function PreRegister() {
  const [isMobile, setIsMobile] = useState(false);
  const [phoneCountry, setPhoneCountry] = useState("US");

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);
    window.scrollTo({ top: 0, behavior: "smooth" });

    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const [formData, setFormData] = useState({
    name: "",
    age: "",
    email: "",
    mobile: "",
    instagram: "",
    country: "",
    city: "",
    work: "",
    favorite_spots: "",
    linkedin: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState(""); // 'success' or 'error'

  const handleFieldChange = (name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate form
    if (!formData.name.trim() || !formData.email.trim()) {
      setMessage("Please complete all fields");
      setMessageType("error");
      return;
    }

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      setMessage("Please enter a valid email address");
      setMessageType("error");
      return;
    }

    const age = parseInt(formData.age, 10);
    if (isNaN(age) || age < 18 || age > 100) {
      setMessage("Please enter a valid age between 18 and 100");
      setMessageType("error");
      return;
    }

    const mobileRegex = /^\d{7,15}$/; // Simple regex for mobile number
    if (!mobileRegex.test(formData.mobile)) {
      setMessage("Please enter a valid mobile number (7-15 digits)");
      setMessageType("error");
      return;
    }

    const instagramRegex = /^@?(\w){1,30}$/; // Simple regex for Instagram handle
    if (!instagramRegex.test(formData.instagram)) {
      setMessage("Please enter a valid Instagram handle");
      setMessageType("error");
      return;
    }

    // Debounce - prevent multiple submissions
    if (isSubmitting) {
      return;
    }

    setIsSubmitting(true);
    setMessage("");

    try {
      const response = await fetch(process.env.REACT_APP_PRE_REGISTRATION_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name: formData.name,
          age: formData.age,
          email: formData.email,
          mobile_number: formData.mobile,
          city: formData.city,
          instagram: formData.instagram,
          country: formData.country,
          work: formData.work,
          favorite_spots: formData.favorite_spots,
          linkedin: formData.linkedin,
        }),
      });

      if (response.ok) {
        setMessage("Registration successful! Thank you for signing up.");
        setMessageType("success");
        setFormData({
          name: "",
          age: "",
          email: "",
          mobile: "",
          instagram: "",
          country: "",
          work: "",
          favorite_spots: "",
          city: "",
          linkedin: "",
        });

        // Re-enable submit button after 3 seconds
        setTimeout(() => {
          setIsSubmitting(false);
        }, 3000);
      } else {
        const errorData = await response.json();
        if (errorData.message.email) {
          setMessage(errorData.message.email);
        } else {
          if (errorData.message.mobile_number) {
            setMessage(errorData.message.mobile_number);
          } else {
            if (errorData.message.linkedin) {
              setMessage(errorData.message.linkedin);
            } else {
              setMessage("Registration error. Please try again.");
            }
          }
        }

        setMessageType("error");
        // Re-enable submit button after 2 seconds on error
        setTimeout(() => {
          setIsSubmitting(false);
        }, 2000);
      }
    } catch (error) {
      setMessage("Connection Error. Try again later.");
      setMessageType("error");
      // Re-enable submit button after 2 seconds on error
      setTimeout(() => {
        setIsSubmitting(false);
      }, 2000);
    }
  };

  return (
    <div className="App">
      <div className="videoOpacity"></div>
      <div className="videoContainer">
        <div className="videoOpacity"></div>
        <video
          id="videoID"
          playsInline
          autoPlay
          muted
          loop
          webkit-playsinline="true"
          className="videoBody"
        >
          <source
            src={isMobile ? yoyovideoMobile : yoyovideoDesktop}
            type={isMobile ? "video/webm" : "video/mp4"}
          />
        </video>
      </div>

      <div className="back-button-container">
        <BackButton></BackButton>
      </div>

      <div className="bodyContainer">
        <>
          <div className="spacer"></div>
        </>
        <div className="mainContainer">
          <div className="preregister-form">
            <img
              src={yoyoLogo}
              className="preregister-yoyoLogo"
              alt="YoYo Logo"
            />
            <p className="preregister-title">Friends & family membership sign-up</p>
            <p className="preregister-text">Sign Up</p>
          </div>
          <form
            className="preregister-form"
            style={{ overflow: "visible" }}
            onSubmit={handleSubmit}
            novalidate
            noValidate
          >
            <div className="preregister-divider"></div>
            <div className="form-group" style={{ overflow: "visible" }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "10px",
                  overflow: "visible",
                }}
              >
                <p className="formtitle">Full name</p>
                <Tooltip
                  src={logo}
                  alt="info icon"
                  text="Exactly as it appears on your official ID. This keeps your membership seamless and secure."
                />
              </div>

              <FormField
                id="name"
                label="Your full name"
                value={formData.name}
                onChange={(value) => handleFieldChange("name", value)}
                disabled={isSubmitting}
              />
            </div>

            <div className="form-group" style={{ overflow: "visible" }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "10px",
                  overflow: "visible",
                }}
              >
                <p className="formtitle">Age</p>
                <Tooltip
                  positionX="-30%"
                  src={logo}
                  alt="info icon"
                  text="Certain experiences are age-gated by design."
                />
              </div>

              <FormField
                id="age"
                label="Your age"
                type="number"
                value={formData.age}
                onChange={(value) => handleFieldChange("age", value)}
                disabled={isSubmitting}
              />
            </div>

            <div className="form-group" style={{ overflow: "visible" }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "10px",
                  overflow: "visible",
                }}
              >
                <p className="formtitle">Email</p>
                <Tooltip
                  positionX="-35%"
                  src={logo}
                  alt="info icon"
                  text="Where we’ll send your invite, updates, and anything you wouldn’t want to miss."
                />
              </div>

              <FormField
                id="email"
                label="Email address"
                type="email"
                value={formData.email}
                onChange={(value) => handleFieldChange("email", value)}
                disabled={isSubmitting}
              />
            </div>

            <div className="form-group" style={{ overflow: "visible" }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "10px",
                  overflow: "visible",
                }}
              >
                <p className="formtitle">Phone Number</p>
                <Tooltip
                  src={logo}
                  alt="info icon"
                  text="For priority access, confirmations, and time-sensitive drops."
                />
              </div>

              <PhoneNumberField
                countryIso2={phoneCountry}
                phone={formData.mobile}
                onCountryChange={setPhoneCountry}
                onPhoneChange={(value) => handleFieldChange("mobile", value)}
                countryLabel="Country"
                phoneLabel="Mobile number"
                disabled={isSubmitting}
              />
            </div>

            <div className="form-group" style={{ overflow: "visible" }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "10px",
                  overflow: "visible",
                }}
              >
                <p className="formtitle">Instagram</p>
                <Tooltip
                  src={logo}
                  alt="info icon"
                  text="Public profile preferred. It helps us understand your world, taste, and energy."
                />
              </div>

              <FormField
                id="instagram"
                label="Instagram handle"
                value={formData.instagram}
                onChange={(value) => handleFieldChange("instagram", value)}
                disabled={isSubmitting}
              />
            </div>

            <div className="form-group" style={{ overflow: "visible" }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "10px",
                  overflow: "visible",
                }}
              >
                <p className="formtitle">LinkedIn</p>
                <Tooltip
                  positionX="-40%"
                  src={logo}
                  alt="info icon"
                  text="It gives us a fuller picture of your professional world and creative landscape."
                />
              </div>

              <FormField
                id="linkedin"
                label="Linkedin"
                value={formData.linkedin}
                onChange={(value) => handleFieldChange("linkedin", value)}
                disabled={isSubmitting}
              />
            </div>

            <div className="form-group" style={{ overflow: "visible" }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "10px",
                  overflow: "visible",
                }}
              >
                <p className="formtitle">Country</p>
                <Tooltip
                positionX="-40%"
                  src={logo}
                  alt="info icon"
                  text="YoYo experiences adapt by location."
                />
              </div>

              <FormField
                id="country"
                label="Country"
                value={formData.country}
                onChange={(value) => handleFieldChange("country", value)}
                disabled={isSubmitting}
              />
            </div>

            <div className="form-group" style={{ overflow: "visible" }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "10px",
                  overflow: "visible",
                }}
              >
                <p className="formtitle">City</p>
                <Tooltip
                  positionX="-30%"
                  src={logo}
                  alt="info icon"
                  text="So we know where to meet you."
                />
              </div>

              <FormField
                id="city"
                label="City"
                value={formData.city}
                onChange={(value) => handleFieldChange("city", value)}
                disabled={isSubmitting}
              />
            </div>

            <div className="form-group" style={{ overflow: "visible" }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "10px",
                  overflow: "visible",
                }}
              >
                <p className="formtitle">What do you do for a living?</p>
                <Tooltip
                  src={logo}
                  alt="info icon"
                  text="Your role, industry, or main creative lane. Titles are optional — clarity is not."
                />
              </div>

              <FormField
                id="work"
                label="What do you do for a living?"
                value={formData.work}
                onChange={(value) => handleFieldChange("work", value)}
                disabled={isSubmitting}
              />
            </div>

            <div className="form-group" style={{ overflow: "visible" }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "10px",
                  overflow: "visible",
                }}
              >
                <p className="formtitle">Your usual spots (upt to 3)</p>
                <Tooltip
                  src={logo}
                  alt="info icon"
                  text="Bars, restaurants, or places you genuinely go back to. This helps us curate experiences that feel natural to you."
                />
              </div>

              <FormField
                id="favorite_spots"
                label="Your usual spots (up to 3)"
                value={formData.favorite_spots}
                onChange={(value) => handleFieldChange("favorite_spots", value)}
                disabled={isSubmitting}
              />
            </div>

            {message && (
              <div className={`message ${messageType}`}>{message}</div>
            )}

            <div               style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
              }}>
              <p className="pre-register-disclaimer" style={{}}>
              Every request is reviewed by a human team. <br></br> We’ll be in
              touch.
            </p>
            </div>
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <button
                type="submit"
                className="yoyo-pill--white"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Applying..." : "Apply for YOYO membership"}
              </button>
            </div>
          </form>
        </div>

        <div>
          <div
            className="textFooterContainer"
            style={{
              width: "100%",
              gap: "10px",
              paddingBottom: "32px",
              paddingTop: "24px",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <p className="textFotter">YOYO© All Rights Reserved 2026</p>
            <a href="https://www.google.com" className="textFotterLink">
              Privacy Policy
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PreRegister;
